import { Component, OnInit } from '@angular/core';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.css']
})
export class OurServicesComponent implements OnInit {
  serviceList = [];
  dataLimit = 9;
  skipValue = 0;
  customerList = [];
  noDataCheck: boolean = false

  constructor(private rolesSharedService: RolesSharedService,
    private router: Router,
    private breadcrumService:BreadcrumService) { 
  }

  ngOnInit() {
    this.getOurservices();
        this.getOurCustomerDetails();

  }
  getOurservices() {
    let type = 'our_services'
    this.rolesSharedService.getCustomerDeatils(type).subscribe((response) => {
      this.serviceList = response[0].cmsPost[0].cmsPostDetails;
      this.serviceList = _.orderBy(this.serviceList, ['sequence'], ['asc']);
      if(this.serviceList.length === 0) {
       this.noDataCheck = true;
      }
    }
  );
  }
  onScrollDown() {
    if(this.serviceList.length>0){
    this.skipValue = this.skipValue + 9;
    }
  }
  routeContactUs() {
    this.router.navigate(["contact-us"]);
  }
  getOurCustomerDetails() {
    let type = 'our_customers'
    this.rolesSharedService.getCustomerDeatils(type).subscribe((response) => {
      this.customerList = response[0].cmsPost[0].cmsPostDetails;
      this.customerList = this.customerList.sort((a, b) => (new Date (b.createdAt ).getTime()) - (new Date (a.createdAt).getTime()));
    }
  );
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/external/our-services/our-services.component.ts